import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bcrypt from "bcryptjs";
import "./AddAgent.css";
import AdminLayout from "./AdminLayout";

const AddAgent = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    agentName: "",
    phoneNumber: "",
    nonAgence: "",
    territoire: "",
    langue: "",
    presentation: "",
    infosSupplementaires: "",
    adresse: "",
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setPhotoFile(e.target.files[0]);
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validateForm = () => {
    const {
      email, password, agentName, phoneNumber,
      nonAgence, territoire, langue
    } = formData;

    if (!email || !password || !agentName || !phoneNumber || !nonAgence || !territoire || !langue || !photoFile) {
      alert("Tous les champs obligatoires doivent être remplis.");
      return false;
    }

    if (password.length < 8) {
      alert("Le mot de passe doit contenir au moins 8 caractères.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      // Hachage du mot de passe
      const salt = await bcrypt.genSalt(10);
      const hashedPassword = await bcrypt.hash(formData.password, salt);

      const data = new FormData();
      // Ajout de tous les champs sauf le mot de passe
      Object.entries(formData).forEach(([key, value]) => {
        if (key !== "password") {
          data.append(key, value);
        }
      });
      
      // Ajout du mot de passe haché
      data.append("password", hashedPassword);
      data.append("photoProfil", photoFile);

      const response = await axios.post("https://keurgui-backend-kjour.ondigitalocean.app/api/agents", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Agent ajouté avec succès !");
      navigate("/agnts");

      // Réinitialisation du formulaire
      setFormData({
        email: "",
        password: "",
        agentName: "",
        phoneNumber: "",
        nonAgence: "",
        territoire: "",
        langue: "",
        presentation: "",
        infosSupplementaires: "",
        adresse: "",
      });
      setPhotoFile(null);

    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      alert(error.response?.data?.message || "Échec de l'ajout de l'agent. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout>
    <div className="add-agent-container">
      <h2>Ajouter un nouvel agent</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input 
          type="text" 
          name="agentName" 
          value={formData.agentName} 
          onChange={handleChange} 
          placeholder="Nom de l'agent" 
          required 
        />
        
        <input 
          type="email" 
          name="email" 
          value={formData.email} 
          onChange={handleChange} 
          placeholder="Email" 
          required 
        />
        
        <div className="password-container">
          <input 
            type={passwordVisible ? "text" : "password"} 
            name="password" 
            value={formData.password} 
            onChange={handleChange} 
            placeholder="Mot de passe (min 8 caractères)" 
            required 
            minLength="8"
          />
          <button 
            type="button" 
            onClick={togglePasswordVisibility}
            className="toggle-password"
          >
            {passwordVisible ? "Masquer" : "Afficher"}
          </button>
        </div>
        
        <input 
          type="text" 
          name="phoneNumber" 
          value={formData.phoneNumber} 
          onChange={handleChange} 
          placeholder="Téléphone" 
          required 
        />
        
        <input 
          type="text" 
          name="nonAgence" 
          value={formData.nonAgence} 
          onChange={handleChange} 
          placeholder="Nom de l'agence" 
          required 
        />
        
        <input 
          type="text" 
          name="territoire" 
          value={formData.territoire} 
          onChange={handleChange} 
          placeholder="Territoire" 
          required 
        />
        
        <input 
          type="text" 
          name="langue" 
          value={formData.langue} 
          onChange={handleChange} 
          placeholder="Langue" 
          required 
        />
        
        <div className="file-input-container">
          <label>Photo de profil :</label>
          <input 
            type="file" 
            name="photoProfil" 
            accept="image/*" 
            onChange={handleFileChange} 
            required 
          />
        </div>
        
        <textarea 
          name="presentation" 
          value={formData.presentation} 
          onChange={handleChange} 
          placeholder="Présentation (optionnel)" 
        />
        
        <textarea 
          name="infosSupplementaires" 
          value={formData.infosSupplementaires} 
          onChange={handleChange} 
          placeholder="Informations supplémentaires (optionnel)" 
        />
        
        <input 
          type="text" 
          name="adresse" 
          value={formData.adresse} 
          onChange={handleChange} 
          placeholder="Adresse (optionnel)" 
        />
        
        <button 
          type="submit" 
          disabled={isSubmitting}
          className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
        >
          {isSubmitting ? 'En cours...' : 'Ajouter l\'agent'}
        </button>
      </form>
    </div>
    </AdminLayout>
  );
};

export default AddAgent;